module.exports = __webpack_public_path__ + "media/images/emblems/TI-Cugnasco-Gerra-b3c0d0db2bfd87ad6e2d815354b33cda.png";